'use client'

import { Typography, Grid, Stack, Fade } from '@mui/material'
import styled from '@emotion/styled'
import { Trans } from 'react-i18next'
import { useRef } from 'react'
import useOnScreen from '@hooks/useOnScreen'

const GridRoot = styled(Grid, { label: 'Utility-GridRoot' })(
  ({ theme }: any) => ({
    height: '100%',
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      // Below 900px
      flexDirection: 'column-reverse',
    },
  }),
)

const UtilityTypography = styled(Typography, { label: 'UtilityTitle' })(
  ({ theme, variant }: any) => ({
    [theme.breakpoints.down('sm')]: {
      // Below 600px
    },
    fontSize: variant === 'body1' ? '1.5rem' : '',
    fontWeight: variant === 'body1' ? '300' : '',
  }),
)

function UtilityDescriptionPage() {
  const root = useRef()
  const isVisible = useOnScreen(root)

  return (
    <Fade in={isVisible} timeout={2000} ref={root}>
      <GridRoot
        container
        spacing={8}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <UtilityTypography variant="h2">
              <Trans i18nKey="UtilityDescriptionPage.title" />
            </UtilityTypography>
            <UtilityTypography
              variant="body1"
              fontFamily="sans-serif"
              style={{ opacity: 0.6 }}
            >
              <Trans i18nKey="UtilityDescriptionPage.text1" />
            </UtilityTypography>
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <img
            style={{
              maxWidth: '600px',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 2,
              borderRadius: '20px',
            }}
            className="utility-image"
            alt="pic"
            src="/assets/partnerships.gif"
          />
        </Grid>
      </GridRoot>
    </Fade>
  )
}

export default UtilityDescriptionPage
